/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorContainer from "./errorContainer/errorContainer";
import LoadingContainer from "./loadingContainer/loadingContainer";

import { fetchUploadData, resetStateUploads } from "../app/slices/uploadSlice";

const ViewUploadDialog = ({ open, handleClose, upload }) => {
  const { list, status, error } = useSelector(
    ({ uploads }) => uploads.getBase64
  );
  const dispatch = useDispatch();

  const [data, setData] = useState(null);

  useEffect(() => {
    resetStateUploads(["getBase64"]);
    loadResources();
    return () => {
      resetStateUploads(["getBase64"]);
    };
  }, []);

  useEffect(() => {
    if (list?.length) {
      if (upload.TYPE !== "events") {
        window.open(list[0]?.DATA, "_blank");
        handleClose();
      } else {
        setData(list[0]?.DATA);
      }
    }
  }, [list]);

  //* methods
  const loadResources = () => {
    dispatch(fetchUploadData({ UPLOAD_ID: upload?.UPLOAD_ID }));
  };

  //builders

  const BuildView = () => {
    if (data) {
      return (
        <div className="upload-view-container">
          <img style={{ objectFit: "fill" }} src={data} alt="img" />
        </div>
      );
    } else {
      return (
        <div
          className="p-20 flex-row justify-content-center align-items-center"
          style={{ height: "350px" }}
        >
          Oops, File format not supported!
        </div>
      );
    }
  };

  return (
    <Dialog open={open} maxWidth={"lg"} fullWidth>
      <DialogContent>
        <DialogContentText style={{ height: "calc(100vh - 180px)" }}>
          {status === "idle" && list?.length > 0 && <>{BuildView()}</>}

          {status === "loading" && (
            <LoadingContainer
              message="Working on it..."
              hasBackground={false}
            />
          )}

          {error !== null && status !== "loading" && (
            <ErrorContainer
              message={error?.message}
              hasBackground={false}
              onReload={() => {
                loadResources();
              }}
            />
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          id="btn-close"
          margin="dense"
          color="secondary"
          variant="contained"
          onClick={handleClose}
          style={{ marginLeft: "10px" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewUploadDialog;
